import templateUrl from "./datepicker.html";

export const datepickerComponent = {
  bindings: {
    details: "<",
    onChange: "&",
    disableDate: "<",
    disableStartDateIfItIsPastDate: "<",
  },
  templateUrl,
  controller: class DatepickerComponent {
    constructor($state, DateService) {
      "ngInject";

      this.$state = $state;
      this.dateService = DateService;
    }

    $onInit() {
      this.stateName = this.$state.$current.name;
      this.datepickerOptions = {};
      this.startDatepickerOptions = {};
      this.endDatepickerOptions = {};
      //this.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
      //this.format = this.formats[1];
      if (!this.details) {
        this.details = {};
      }
      if (!this.details.hasOwnProperty("isRequired")) {
        this.details.isRequired = true;
      }
      // if(this.details.selectedDate) {
      // 	this.details.selectedDate = this.details.selectedDate.toString();
      // }
      if (this.details.range) {
        this.startDatePopupOpened = false;
        this.endDatePopupOpened = false;
        if (this.details.range.startDate.minDate) {
          this.startDatepickerOptions.minDate = angular.copy(
            this.details.range.startDate.minDate || new Date()
          );
        }
        if (this.details.range.startDate.disablePreviousDates) {
          this.startDatepickerOptions.minDate.setDate(
            this.startDatepickerOptions.minDate.getDate() + 1
          );
        }
        if (this.details.range.endDate.minDate) {
          this.endDatepickerOptions.minDate = angular.copy(
            this.details.range.endDate.minDate || new Date()
          );
        }
        if (this.details.range.endDate.disablePreviousDates) {
          this.endDatepickerOptions.minDate.setDate(
            this.endDatepickerOptions.minDate.getDate() + 1
          );
        }
        if (!this.details.range.startDate.hasOwnProperty("isRequired")) {
          this.details.range.startDate.isRequired = true;
        }
        if (!this.details.range.endDate.hasOwnProperty("isRequired")) {
          this.details.range.endDate.isRequired = true;
        }
        //disabled future dates
        if (this.details.range.startDate.maxDate) {
          this.startDatepickerOptions.maxDate = angular.copy(
            this.details.range.startDate.maxDate || new Date()
          );
        }
        if (this.details.range.startDate.disableFutureDates) {
          this.startDatepickerOptions.maxDate.setDate(
            this.startDatepickerOptions.maxDate.getDate() - 1
          );
        }
        if (this.details.range.endDate.maxDate) {
          this.endDatepickerOptions.maxDate = angular.copy(
            this.details.range.endDate.maxDate || new Date()
          );
        }
        if (this.details.range.endDate.disableFutureDates) {
          this.endDatepickerOptions.maxDate.setDate(
            this.endDatepickerOptions.maxDate.getDate() - 1
          );
        }

        if (
          this.details.range.startDate.disableFutureDates &&
          this.details.range.startDate.enableCurrentDateSelection
        ) {
          this.startDatepickerOptions.maxDate = new Date();
          this.startDatepickerOptions.maxDate.setDate(
            this.startDatepickerOptions.maxDate.getDate()
          );
        }
        if (
          this.details.range.endDate.disableFutureDates &&
          this.details.range.endDate.enableCurrentDateSelection
        ) {
          this.endDatepickerOptions.maxDate = new Date();
          this.endDatepickerOptions.maxDate.setDate(
            this.endDatepickerOptions.maxDate.getDate()
          );
        }

        if (this.details.disableFutureDatesSpecificToEndDate) {
          this.endDatepickerOptions.maxDate =
            this.details.range && this.details.range.startDate.selectedDate
              ? this.dateService.addDays(
                  this.details.range.startDate.selectedDate,
                  364
                )
              : new Date();
          if (this.endDatepickerOptions.maxDate !== "") {
            if (this.endDatepickerOptions.maxDate > new Date()) {
              this.endDatepickerOptions.maxDate = new Date();
            }
          }
          this.endDatepickerOptions.maxDate.setDate(
            this.endDatepickerOptions.maxDate.getDate() - 1
          );
        }

        if (
          this.details.range.endDate.disableFutureDates &&
          this.details.range.endDate.enableCurrentDateSelection
        ) {
          this.endDatepickerOptions.maxDate = new Date();
          this.endDatepickerOptions.maxDate.setDate(
            this.endDatepickerOptions.maxDate.getDate()
          );
        }
      } else {
        if (this.details.disablePreviousDates) {
          if (this.details.minDate) {
            this.datepickerOptions.minDate = new Date(this.details.minDate);
            this.datepickerOptions.minDate.setDate(
              this.datepickerOptions.minDate.getDate() + 1
            );
          } else {
            this.datepickerOptions.minDate = new Date();
          }

          if (this.details.disablePreviousDatesAndCurrentDate) {
            let currentDate = new Date();
            this.datepickerOptions.minDate = new Date(
              currentDate.setDate(currentDate.getDate() + 1)
            );
          }

          if (this.details.maxDate) {
            this.datepickerOptions.maxDate = new Date(this.details.maxDate);
            this.datepickerOptions.maxDate.setDate(
              this.datepickerOptions.maxDate.getDate() - 1
            );
          } else {
            this.datepickerOptions.maxDate = null;
          }
        }

        //disabled future dates
        if (this.details.disableFutureDates) {
          this.datepickerOptions.maxDate = new Date();
          this.datepickerOptions.maxDate.setDate(
            this.datepickerOptions.maxDate.getDate() - 1
          );
        }
      }

      if (
        this.details.range &&
        this.details.range.endDate.disableFutureDates &&
        this.details.range.endDate.enableCurrentDateSelection
      ) {
        this.endDatepickerOptions.maxDate = new Date();
        this.endDatepickerOptions.maxDate.setDate(
          this.endDatepickerOptions.maxDate.getDate()
        );
      }
    }
    open() {
      if (!this.details.disableDate) this.opened = true;
    }
    openStartDatePopup() {
      this.startDatePopupOpened = true;
    }
    openEndDatePopup() {
      this.endDatePopupOpened = true;
    }

    getDisablePastStartDate(startDate) {
      if (this.disableStartDateIfItIsPastDate === true && startDate !== "") {
        return this.dateService.isPastDate(new Date(), startDate);
      }
      return false;
    }

    $onChanges(changes) {
      if (changes.details && changes.details.currentValue) {
        this.$onInit();
      }
    }

    _onChangeSingleDatePicker(details) {
      this.onChange({
        details,
      });
    }

    _onChange(details) {
      const _details = Object.assign({}, details);

      if (details.range.startDate.disablePreviousDates) {
        this.startDatepickerOptions.minDate = angular.copy(
          details.range.startDate.minDate || new Date()
        );
        this.startDatepickerOptions.minDate.setDate(
          this.startDatepickerOptions.minDate.getDate() + 1
        );
      }

      if (details.range.endDate.disablePreviousDates) {
        this.endDatepickerOptions.minDate =
          angular.copy(_details.range.startDate.selectedDate) || new Date();
        this.endDatepickerOptions.minDate.setDate(
          this.endDatepickerOptions.minDate.getDate() + 1
        );
      }

      if (details.range.startDate.disableFutureDates) {
        this.startDatepickerOptions.maxDate = angular.copy(
          details.range.startDate.maxDate || new Date()
        );
        this.startDatepickerOptions.maxDate.setDate(
          this.startDatepickerOptions.maxDate.getDate() - 1
        );
      }

      if (details.range.endDate.disableFutureDates) {
        this.endDatepickerOptions.maxDate = angular.copy(
          this.details.range.endDate.maxDate || new Date()
        );
        this.endDatepickerOptions.maxDate.setDate(
          this.endDatepickerOptions.maxDate.getDate() - 1
        );
      }

      if (
        this.details.range &&
        this.details.range.endDate.endDateGreaterThanStartDate
      ) {
        this.endDatepickerOptions.minDate = new Date(
          this.details.range.startDate.selectedDate
        );
        this.endDatepickerOptions.minDate.setDate(
          this.endDatepickerOptions.minDate.getDate() + 1
        );
      }

      if (this.details.disableFutureDatesSpecificToEndDate) {
        this.endDatepickerOptions.maxDate =
          this.details.range && this.details.range.startDate.selectedDate
            ? this.dateService.addDays(
                this.details.range.startDate.selectedDate,
                364
              )
            : new Date();
        if (this.endDatepickerOptions.maxDate !== "") {
          if (this.endDatepickerOptions.maxDate > new Date()) {
            this.endDatepickerOptions.maxDate = new Date();
          }
        }
        this.endDatepickerOptions.maxDate.setDate(
          this.endDatepickerOptions.maxDate.getDate() - 1
        );
      }

      if (
        this.details.range &&
        this.details.range.endDate.disableFutureDates &&
        this.details.range.endDate.enableCurrentDateSelection
      ) {
        this.endDatepickerOptions.maxDate = new Date();
        this.endDatepickerOptions.maxDate.setDate(
          this.endDatepickerOptions.maxDate.getDate()
        );
      }
      this.onChange({
        details,
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/datepicker/datepicker.component.js